import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type AddToPlan =
  | OpalApi<'MomentsAddToPlanBFFV1', 200>
  | OpalApi<'MomentsAddToPlanBFFV1', 202>

export const createMomentsToPlanRequest: AddToPlan = async (args = {}) => {
  const url = new URL(
    '/asgard-bff/moments/add_to_plan/',
    window.location.origin
  )

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => {
      if (res.status === 202) return
      return res.data
    })
}
